export enum TOAST_MESSAGES {
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  INFO = "info",
  DISABLE = "disable",
}

export enum PORTAL {
  ADMIN = "admin",
  CLIENT = "client",
}

export enum AUTH_TYPE {
  PRE_AUTH = "PreAuth",
  POST_AUTH = "PostAuth",
}

export enum USER_STATUS {
  ACTIVE = "ACTIVE",
  BLOCKED = "BLOCKED",
  DISABLED = "DISABLED",
}

export enum PATTERN {
  PASSWORD = "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,16}$",
  EMAIL = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
  NUMBER = "^[0-9]*$",
}

export enum EVENT {
  SHOW_HIDE_LOADER = "SHOW_HIDE_LOADER",
  REFRESH_BANK_DETAILS = "REFRESH_BANK_DETAILS",
  REFRESH_WALLET = "REFRESH_WALLET",
  USER_PROFILE = "USER_PROFILE",
  REFRESH_OPEN_ORDERS = "REFRESH_OPEN_ORDERS",
  REFRESH_WATCH_LIST = "REFRESH_WATCH_LIST",
}

export enum KTO_STATUS_CODE {
  ERR_113 = "KTO_ERR_113",
  ERR_114 = "KTO_ERR_114",
  ERR_115 = "KTO_ERR_115",
  ERR_153 = "KTO_ERR_153",
  ERR_401 = "KTO_ERR_401",
  ERR_403 = "KTO_ERR_403",
  ERR_409 = "KTO_ERR_409",
}

export enum OTP_FOR {
  UPDATE_PHONE = "updatePhone",
  UPDATE_EMAIL = "updateEmail",
}

export enum USD_DAYS_STRING {
  _1Dusd = "1Dusd",
  _7Dusd = "7Dusd",
  _1Musd = "1Musd",
  _3Musd = "3Musd",
  _1Yusd = "1Yusd",
  _ALLusd = "ALLusd",
}

export enum USD_DAYS_NUMBER {
  _1 = 1,
  _7 = 7,
  _30 = 30,
  _90 = 90,
  _365 = 365,
  _All = -1,
}

export enum CURRENCIES {
  USD = "usd",
}

export enum LOCAL_STORAGE {
  watchlist = "watchlist",
}

export enum INFO_SHARE {
  BREAD_CRUMBS = "bread-crumbs",
  NO_VIEW_ALL = "no-view-all",
}

export enum ACTIONS {
  PRIMARY_CLICKED = "PRIMARY_CLICKED",
  SECONDARY_CLICKED = "SECONDARY_CLICKED",
  CANCEL = "CANCEL",
}

export enum PRE_AUTH_STEPS {
  LOGIN = "LOGIN",
  VERIFY_EMAIL_NUMBER = "VERIFY_EMAIL_NUMBER",
  VERIFY_OTP = "VERIFY_OTP",
  AUTH_OPTIONS = "AUTH_OPTIONS",
  TWO_FA_VERIFICATION = "TWO_FA_VERIFICATION",
}

export enum TRANSACTION_TYPE {
  BUY = "buy",
  SELL = "sell",
}

export enum ORDER_TYPE {
  DIRECT = "direct",
  LIMIT = "limit",
  MARKET = "market",
}

export enum HeaderType {
  text = "text",
  date = "date",
  boolean = "boolean",
  action = "action",
  status = "status",
  toggle = "toggle",
  html = "html",
  slide = "slide",
  pair = "pair",
}
export enum TableActionType {
  edit = "edit",
  cancel = "Cancel",
  pending = "Pending",
  delete = "delete",
  view = "view",
  route = "route",
  plainText = "plainText",
  checkBox = "checkBox",
}
export enum orderTable {
  openOrder = "open-orders",
  orderHistory = "order-history",
  tradeHistory = "trade-history",
}

export enum TokenPairFilter {
  FAVORITE = "FAVORITE",
  ALL = "ALL",
  KTO = "KTO",
  BTC = "BTC",
  USDT = "USDT",
}

export enum SORT_DIRECTION {
  ASC = "asc",
  DESC = "desc",
  DEFAULT = "default",
}

export enum OrderTradeTabsType {
  OPEN_ORDERS = "open-orders",
  ORDER_HISTORY = "order-history",
  TRADE_HISTORY = "trade-history",
}

export enum ORDER_STATUS {
  PENDING = "pending",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export enum ORDER_SIDE {
  BID = "bid",
  ASK = "ask",
}

export enum ACTION_TYPE {
  VIEW_ALL_OPEN_ORDERS = "view-all-open-orders",
  VIEW_ALL_ORDER_HISTORY = "view-all-order-history",
  VIEW_ALL_TRADE_HISTORY = "view-all-trade-history",
}

export enum TAB_TYPE {
  MARKET_TRADES = "market-trades",
  ORDER_BOOK = "order-book",
}

export enum TRADES {
  MARKET_TRADES = "market-trades",
  ALL_DATA = "all-data",
  ASK = "ask-data",
  BID = "bid-data",
}

export enum LOCAL_STORAGE_KEYS {
  WALLET_DETAILS = "walletDetails",
}

export enum SOCKET_EVENTS {
  UPDATE_TRADE = "UPDATE_TRADE",
  CURRENT_PRICE = "CURRENT_PRICE",
  UPDATE_CHART_DATA = "UPDATE_CHART_DATA",
  UPDATE_ORDER_BOOK = "UPDATE_ORDER_BOOK",
}
